import styles from "./Content.module.scss";
import React from "react";
import clsx from "clsx";

export const Content = ({children}) => {
  return <div className={styles.content}>
    {children}
  </div>;
};

export const ContentFixed = ({children}) => {
  return <div className={styles.contentFixed}>
    {children}
  </div>;
};

export const ContentScroll = ({children, whiteBackground, withFab = false, paddingTop = false, className = null}) => {
  const cmpStyle = clsx(
    styles.contentScroll,
    whiteBackground ? styles.white : null,
    withFab ? styles.fab : null,
    paddingTop ? styles.paddingTop : null,
    className,
    "custom-scrollbar"
  );

  return <div className={cmpStyle}>
    {children}
  </div>;
};
